import { Nullable }		from "ts-base/nullable";
import { Base64 }		from "ts-base/base64";
// import { Utf8 }		from "ts-base/utf8";

import { Textual }		from "@v3/data/textual";

// as defined in https://datatracker.ietf.org/doc/html/rfc4648#section-4
export type Base64String	= Textual.Value<typeof Base>;

const Base			=
	Textual.regex(
		"Base64String",
		Base64.regexp,
		"must be an RFC 4648 base64 string"
	);

namespace Extension {
	export const fromUint8Array	= (it:Uint8Array):Base64String	=> Base.brand(Base64.encode(it));

	// this is safe, the string we contain is always valid base64
	export const toUint8Array	= (it:Base64String):Uint8Array	=> Nullable.unsafeGet(Base64.decode(it));

	/*
	export const encodeUtf8	= (it:string):Base64String	=> Base64String.fromUint8Array(Utf8.encode(it));
	export const decodeUtf8	= (it:Base64String):string	=> Utf8.decode(Base64String.toUint8Array(it));
	*/
};

export const Base64String	= { ...Extension, ...Base };
